// Downstream documents edit their saved information without changing identity links.
export default {
  computed: {
    customerInformationDisabled() {
      return this.loading || !this.formHydrationReady || String(this.form.status) !== '0';
    },
    showEditCustomerInformation() {
      return Boolean(this.form._id) && String(this.form.status) === '1';
    },
    showEditVehicleRegistration() {
      return Boolean(this.form._id) && ['0', '1'].includes(String(this.form.status));
    },
  },
  methods: {
    canSubmitInformationEdit(kind) {
      if (this.loading || !this.formHydrationReady) return false;
      return kind === 'vehicle' ? this.showEditVehicleRegistration
        : kind === 'customer' ? this.showEditCustomerInformation : false;
    },
  },
};
